:host{display:flex;width:100%;align-items:center;font-family:Maison Neue,sans-serif}:host .task-label{color:#232426;opacity:.6;min-width:83px}:host .task-id{margin-left:auto}:host button{margin-left:10px}:host button mat-icon{margin-top:-7px;color:#232426de}
/*# sourceMappingURL=task-id.component.css.map */
